module.exports = __webpack_public_path__ + "static/media/frog(6).6fd51152.PNG";